import React, { Component } from 'react';
import { AdminResultControlWrapper } from './AdminResultControlWrapper';
import '../../until925/styles/Results.css';


export class ResultChartWrapper extends Component {
    render() {
         return (
            <div className="voteResultsPage page">
                 <AdminResultControlWrapper activeControls={false} />
            </div>
        )
    }
}